// src/pages/WaitingListAccept.js

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../i18n/LanguageContext';
import { getApiBase } from '../utils/runtime';

function WaitingListAccept() {
  const { request_id } = useParams();
  const navigate = useNavigate();
  const { isEnglish } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const acceptRequest = async () => {
      try {
        const res = await axios.post(
          `${getApiBase()}/waiting-list/${request_id}/accept`
        );
        setMessage(res.data.message || (isEnglish ? 'Your appointment has been confirmed.' : 'Rendez-vous confirme avec succes'));
        setLoading(false);

        setTimeout(() => navigate('/patient/dashboard'), 5000);
      } catch (err) {
        console.error('Error while confirming waitlist slot:', err);
        setError(
          err?.response?.data?.error ||
          (isEnglish ? 'Something went wrong. Please try again later.' : 'Une erreur est survenue. Merci de reessayer plus tard.')
        );
        setLoading(false);
      }
    };

    acceptRequest();
  }, [request_id, navigate, isEnglish]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      {loading && <p>{isEnglish ? 'Confirming your appointment...' : 'Confirmation en cours...'}</p>}
      {message && <p style={{ color: 'green', fontWeight: 'bold' }}>{message}</p>}
      {error && <p style={{ color: 'red', fontWeight: 'bold' }}>{error}</p>}
    </div>
  );
}

export default WaitingListAccept;
